import request from './request';

/**
 * 获取店铺信息
 */
export function getShopInfo(params) {
    // return request(`/org/${params.id}/setting`, {
    return request('/org/setting', {
        method: 'GET',
        params,
    });
}
/**
 * 编辑店铺信息
 */
export function editShopInfo(params) {
    return request('/org/setting', {
        method: 'PUT',
        params,
    });
}
/**
 * 搜索车辆品牌
 */
export function getBrands(params) {
    return request('/vehicle/brand/search', {
        method: 'GET',
        params,
    });
}
/**
 * 获取行政区划代码树
 */
export function getAreaCode(params) {
    return request('/area/code/tree', {
        method: 'GET',
        params,
    });
}
/**
 * 查询店铺位置
 */
export function getAddress() {
    return request('/org/address', {
        method: 'GET',
    });
}
